import { useEffect, useRef, useState } from "react";
import ChadhavaView from "../../Views/Chadhava/ChadhavaView";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ParentView from "../../Views/PrarentView/ParentView";
import {
  getChadhavaPackageListAction,
  getChadhavaTempleList,
} from "../../store/actions/ChadhawaAction";
import { pageReady } from "../../store/slices/pageViewSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";

function ChadhavaScreen() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { cartInfo } = useSelector((state: any) => state.cart);
  const { chadhavaTempleList, isLoading } = useSelector(
    (state: any) => state.chadhawa,
  );
  const [chadhavaPackagesList, setChadhavaPackagesList] = useState<any[]>([]);
  const listingViewedRef = useRef<boolean>(false);

  useEffect(() => {
    dispatch(getChadhavaTempleList());
  }, []);

  useEffect(() => {
    dispatch(getChadhavaPackageListAction())
      .then((res: any) => {
        if (res) {
          setChadhavaPackagesList(res);
        }
      })
      .catch((err: any) => {
        console.error("Error in fetching packages:", err);
      });
  }, [dispatch]);

  useEffect(() => {
    const trackPageViewEvent = (chadhavaTempleList: any) => {
      if (!chadhavaTempleList) return;
      if (listingViewedRef.current) return;
      listingViewedRef.current = true;
      dispatch(
        pageReady({
          User_ID:
            JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
              ?.id ?? "Guest User",
          Page_Type: "Chadhava Temple Listing",
          Listing_Type: "Chadhava Listing",
          Total_Items_Shown: chadhavaTempleList?.length ?? 0,
          Device_Type: getDeviceTypeFromUserAgent(),
        }),
      );
    };

    trackPageViewEvent(chadhavaTempleList);
  }, [chadhavaTempleList]);

  const selectChadhavaTemple = (templeDetails: any) => {
    navigate(`/chadhavaDetails/${templeDetails.nameKey}`);
  };

  const selectChadhavaTemplePackage = (chadhavaPackagesList: any) => {
    navigate(`/chadavaPackage?pujaNameKey=${chadhavaPackagesList.pujaNameKey}`);
  };

  return (
    <ParentView>
      <ChadhavaView
        templeList={chadhavaTempleList}
        selectTemple={selectChadhavaTemple}
        selectChadhavaPackageTemple={selectChadhavaTemplePackage}
        cartDetails={cartInfo}
        isLoading={isLoading}
        chadhavaPackagesList={chadhavaPackagesList}
      />
    </ParentView>
  );
}

export default ChadhavaScreen;
